import { translateBackend } from '@assets/i18n/config';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@ovComponents/2-component/accordion/accordion';
import { Box, Typography } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const CalculatorDisclaimer = ({
  options,
}: {
  options: Record<string, unknown>;
}) => {
  const title = translateBackend(options.disclaimerTitle);
  const description = translateBackend(options.disclaimerDescription);

  return (
    <Accordion
      sx={{ '.MuiAccordionSummary-root': { borderTop: 'none !important' } }}
      data-testid='calculator-disclaimer'
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant='bodyMedium' sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {description ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]} linkTarget='_blank'>
            {description}
          </ReactMarkdown>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};
